import { type SelectHTMLAttributes, forwardRef } from 'react';

import { classNames } from './classNames';

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & {
  invalid?: boolean;
};

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ children, className, invalid = false, ...props }, ref) => (
    <select
      ref={ref}
      aria-invalid={invalid || undefined}
      className={classNames(
        'hotam-field',
        'hotam-select',
        invalid && 'hotam-field--invalid',
        className,
      )}
      {...props}
    >
      {children}
    </select>
  ),
);

Select.displayName = 'Select';
